import { Show } from "solid-js";
import { coinIcon } from "~/assets/assets";
import { useDenominationsGridV2Context } from "../context/denominations_grid_v2_context";

type CoinsStripProps = {
  showLowBalanceWarning?: boolean;
};

export function CoinsStrip(props: CoinsStripProps) {
  const gridState = useDenominationsGridV2Context();
  const { internalState, enoughCoinsAvailable } = gridState;
  const { simulationStore, selectedAmount } = internalState;

  const coinsNeeded = () =>
    simulationStore.response?.totalRequiredCoins ?? selectedAmount();
  const hasLowBalance = () => !enoughCoinsAvailable();

  return (
    <div class="flex w-full flex-col gap-3">
      {/* Coins usage display */}
      <div class="flex w-full items-center justify-center gap-2">
        <div class="text-para-3-regular tracking-[-0.14px] text-text-normal-secondary">
          Get using
        </div>
        <div class="flex items-center gap-1">
          <img src={coinIcon} alt="coin" class="h-5 w-5" />
          <div class="text-para-3-semi-bold tracking-[-0.14px] text-warning-base">
            {coinsNeeded().toLocaleString()}
          </div>
        </div>
      </div>

      {/* Low balance warning */}
      <Show when={props.showLowBalanceWarning && hasLowBalance()}>
        <div class="flex w-full items-center justify-center gap-2 rounded-lg bg-error-lighter px-4 py-2">
          <div class="flex items-center gap-1.5">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="text-error-base"
            >
              <path
                d="M8 5.33334V8.00001M8 10.6667H8.00667M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8.00001C1.33333 4.31811 4.3181 1.33334 8 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="text-para-3-medium tracking-[-0.14px] text-error-base">
              Low coin balance
            </div>
          </div>
        </div>
      </Show>
    </div>
  );
}
